import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Models
import mInstallationAsyncOperation from 'models/installationAsyncOperation';
// Custom
import { openDialog, getInstallationAsyncOperationsList } from 'actions';
import { fullListShape } from 'constants/PropTypesShapes';
import SubListTemplate from 'components/templates/SubListTemplate';
import withResources from 'installations/assets/hocs/WithResources';
import AsyncOperationRow from 'installations/assets/asyncOperations/AsyncOperationRow';
import AsyncOperationFilters from 'installations/assets/asyncOperations/AsyncOperationFilters';
import { OpacInstallationContext } from 'components/misc/Contexts';

class AsyncOperationsList extends React.Component {
  constructor(props) {
    super(props);

    this.handleDisplayAsyncOperationHistory = this.handleDisplayAsyncOperationHistory.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);
  }

  // Handlers
  handleDisplayAsyncOperationHistory(asyncOperation) {
    const { params, handleOpenDialog } = this.props;
    handleOpenDialog({
      title: {
        id: 'title.asyncOperationsResourceHistory',
      },
      actions: [
        { type: 'close' },
      ],
      component: {
        type: 'INSTALLATION_ASYNC_OPERATION_HISTORY',
        props: {
          id: params.id,
          asyncOperation,
        },
      },
      size: 'md',
    });
  }

  // Private
  doGetRowComp(props) {
    return (
      <AsyncOperationRow
        {...props}
        onDisplayAsyncOperationHistory={this.handleDisplayAsyncOperationHistory}
      />
    );
  }

  render() {
    const {
      asyncOperations, params, desynchronized, handleGetAsyncOperationsList,
    } = this.props;

    const { timezone } = this.context;

    return (
      <SubListTemplate
        title={
          <LocalizedMessage id="title.asyncOperationsList" />
        }
        name={mInstallationAsyncOperation.name}
        listFeatures={mInstallationAsyncOperation.listFeatures}
        withActions
        nbActions={1}
        displayRefresh
        elementsData={{
          loading: asyncOperations.loading,
          desynchronized,
          elements: asyncOperations.elements,
          handleGetList: (pagination, sort, filters) => handleGetAsyncOperationsList(params.id, pagination, sort, filters, desynchronized),
        }}
        filtersComp={
          <AsyncOperationFilters timezone={timezone} />
        }
        rowComp={this.doGetRowComp}
      />
    );
  }
}

AsyncOperationsList.contextType = OpacInstallationContext;

AsyncOperationsList.propTypes = {
  params: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  asyncOperations: fullListShape.isRequired,
  desynchronized: PropTypes.bool.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
  handleGetAsyncOperationsList: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  asyncOperations: state.installationAsyncOperation.list,
  desynchronized: state.installationAsyncOperation.list.desynchronized,
});

const mapDispatchToProps = (dispatch) => ({
  handleOpenDialog: (props) => {
    dispatch(openDialog(props));
  },
  handleGetAsyncOperationsList: (id, pagination, sort, filters, desynchronized) => {
    dispatch(getInstallationAsyncOperationsList(id, pagination, sort, filters, desynchronized));
  },
});

module.exports = compose(
  withResources(
    (ownProps) => ({ id: ownProps.params.id }),
    ['devices'],
  ),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(AsyncOperationsList);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/asyncOperations/routes/index/components/InstallationAsyncOperationsList.js